import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled, { css } from 'styled-components';
import { H2 } from '@finect/tabular-core/Headings';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';
import { getFont } from '@finect/tabular-utils/getFont';
var headingStyles = function headingStyles(index) {
  return css(["display:inline-block;font-weight:700;", " ", ""], getFont(index, 'compact'), function (_ref) {
    var center = _ref.center;
    return center ? 'text-align: center;' : null;
  });
};
var sizes = {
  xlarge: {
    title: {
      mobile: 3,
      desktop: 4,
      marginBottom: 36
    }
  },
  large: {
    title: {
      mobile: 2,
      desktop: 3,
      marginBottom: 24
    }
  },
  medium: {
    title: {
      mobile: 1,
      desktop: 2,
      marginBottom: 16
    }
  },
  small: {
    title: {
      mobile: 0,
      desktop: 1,
      marginBottom: 8
    }
  }
};
export var Title = styled(H2).withConfig({
  displayName: "Headings__Title",
  componentId: "sc-12gy5t4-0"
})(["display:block;", " ", ";", ""], function (_ref2) {
  var size = _ref2.size;
  return headingStyles(sizes[size].title.mobile);
}, minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref3) {
  var size = _ref3.size;
  return headingStyles(sizes[size].title.desktop);
}), function (_ref4) {
  var bottomMargin = _ref4.bottomMargin,
    size = _ref4.size;
  return bottomMargin ? "margin-bottom: ".concat(sizes[size].title.marginBottom, "px;") : '';
});
export var Subtitle = styled.h3.withConfig({
  displayName: "Headings__Subtitle",
  componentId: "sc-12gy5t4-1"
})(["margin:8px 0 24px;", ";", ";"], function (_ref5) {
  var variant = _ref5.variant;
  return variant === 'bold' ? headingStyles(0) : '';
}, minMediaQueries.miniDesktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    max-width: ", "px;\n  "])), grid(6)));
export var SectionTitle = function SectionTitle(_ref6) {
  var children = _ref6.children,
    _ref6$size = _ref6.size,
    size = _ref6$size === void 0 ? 'large' : _ref6$size,
    _ref6$bottomMargin = _ref6.bottomMargin,
    bottomMargin = _ref6$bottomMargin === void 0 ? false : _ref6$bottomMargin;
  return React.createElement(Title, {
    bottomMargin: bottomMargin,
    size: size
  }, children);
};